<template>
  <div>
    <h1 class="text-center">Update customer profile</h1>
    <List />
  </div>
</template>

<script>
import List from "@/views/POSCustomer/ListPosCustomer.vue";
export default {
  components: {
    List,
  },
};
</script>
